import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoad } from '@/modules/Requests';

/* eslint-disable import/prefer-default-export */
export const useLoadbar = requestName => {
  const requests = useSelector(store => store.requests);
  const dispatch = useDispatch();

  const load = requests?.[requestName]?.loading;

  useEffect(() => {
    dispatch(setLoad(load));
  }, [load]);
};
